/**
 * One kind's on/off.
 *
 * A real `role="switch"` button with `aria-checked`, not a styled checkbox and not a `div`: the
 * state has to reach assistive technology AS a state, and the drawing is never the only channel.
 * It writes immediately — there is no Save on this screen — and it **stays focusable** while the
 * write is in flight, because a control that disables itself under the trainer's own focus drops
 * the keyboard on `<body>` and sends the next Tab back to the skip link.
 *
 * Its accessible name is mobile's own `clients.taskPrefs.a11y.toggle`, so the phone and the web say
 * the same thing about the same switch.
 */

import { useTranslation } from 'react-i18next';

import styles from './taskKinds.module.css';

interface KindSwitchProps {
  readonly name: string;
  /** `true` means this kind REACHES the queue. Muted is the off position. */
  readonly on: boolean;
  readonly onChange: (on: boolean) => void;
}

export function KindSwitch({ name, on, onChange }: KindSwitchProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      role="switch"
      className={styles.switch}
      aria-checked={on}
      aria-label={t('clients.taskPrefs.a11y.toggle', { name })}
      onClick={() => {
        onChange(!on);
      }}
    />
  );
}
